(function () {
	var CARD = '.product-card';
	var PRICE = '.product-card-info .price';
	var ONE = 'product-card-price--one';
	var TALL = 'product-card-price--tall';
	var timer = null;
	var sizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

	function align() {
		var prices = document.querySelectorAll(CARD + ' ' + PRICE);
		if (!prices.length) return;
		var i;
		for (i = 0; i < prices.length; i++) {
			prices[i].classList.remove(ONE, TALL);
			if (sizeObserver) sizeObserver.observe(prices[i]);
		}

		var rows = new Map();
		for (i = 0; i < prices.length; i++) {
			var price = prices[i];
			var rect = price.getBoundingClientRect();
			if (!rect.height) continue;
			var list = price.closest('.carousel, ul, .row') || document.body;
			var lists = rows.get(list);
			if (!lists) rows.set(list, (lists = new Map()));
			var top = Math.round(rect.top + window.pageYOffset);
			var row = lists.get(top);
			if (!row) lists.set(top, (row = { prices: [], wraps: false }));
			row.prices.push(price);
			var lineHeight = parseFloat(getComputedStyle(price).lineHeight) || 24;
			if (rect.height > lineHeight * 1.5) row.wraps = true;
		}

		rows.forEach(function (lists) {
			lists.forEach(function (row) {
				row.prices.forEach(function (price) {
					price.classList.add(row.wraps ? TALL : ONE);
				});
			});
		});
	}

	function schedule() {
		clearTimeout(timer);
		timer = setTimeout(align, 100);
	}

	align();
	window.addEventListener('load', align);
	window.addEventListener('resize', schedule);
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);

	new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			var added = mutations[i].addedNodes;
			for (var j = 0; j < added.length; j++) {
				var node = added[j];
				if (node.nodeType === 1 && (node.matches(CARD) || node.querySelector(CARD))) return schedule();
			}
		}
	}).observe(document.body, { childList: true, subtree: true });

	if (sizeObserver) sizeObserver.observe(document.documentElement);
})();
